
<div class="card">
  <div class="card-body">
    <h3 class="card-title">Account created</h3>
    <p>Before access is granted, you need to verify your email address. Please follow the instructions sent to your email address. </p>
    <p>If you do not receive an email, please check your Junk / Clutter / Spam folders, as this is an automated email which can sometimes get filtered.</p>
    <p>If you have not received an email, please attempt to sign in again and another email will be sent to your email address.</p>
    <p>If you still do not receive an email please contact your Quantexa account manager.</p>
    <br/>

    <a class="btn btn-primary btn-lg q-button" role="button" href="{{originalUrl}}" *ngIf="show_button">
      Back to sign in screen
    </a>
  
  </div>
</div>
